export default {
    active: 'Active',
    completed: 'Completed',
    pending: 'Pending',
    deactivated: 'Cancelled',
};
